import { render, staticRenderFns } from "./screenAudioView.vue?vue&type=template&id=05f2c449&scoped=true&"
import script from "./screenAudioView.vue?vue&type=script&lang=js&"
export * from "./screenAudioView.vue?vue&type=script&lang=js&"
import style0 from "./screenAudioView.vue?vue&type=style&index=0&id=05f2c449&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2c449",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f2c449')) {
      api.createRecord('05f2c449', component.options)
    } else {
      api.reload('05f2c449', component.options)
    }
    module.hot.accept("./screenAudioView.vue?vue&type=template&id=05f2c449&scoped=true&", function () {
      api.rerender('05f2c449', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/screenAudioView.vue"
export default component.exports